<template>
  <v-container max-width="100%"> <!-- style="margin-top: 2%"> -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="documentosDialog" persistent max-width="80%" style="border-radius: 10px;">
          <v-card>
            <v-card-title class="headline">
              <div>{{ $tc('document.self', documentosVeiculo.length) }}</div>
            </v-card-title>
            <v-card-text>
              <v-data-table :headers="headersDocumentos" :items="documentosVeiculo" sort-by="cod_tipo_documento" dense
                class="elevation-7" locale="pt" style="border-radius: 10px;">

                <template v-slot:top>
                  <v-toolbar flat color="white" style="border-radius: 10px;">
                    <v-spacer></v-spacer>
                    <v-dialog v-model="addDocDialog" max-width="100%">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline" style="color: #4a4a4a">{{
                            formTitleDoc
                            }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container>
                            <v-form ref="formDoc" v-model="formDocValidado">
                              <v-row>
                                <v-col cols="12" sm="3">
                                  <v-select :items="tiposDocumentos" v-model="editedDoc.id_tipo_documento"
                                    item-text="cod_tipo_documento" item-value="id_tipo_documento"
                                    :disabled="tipoDocumentoDisabled" :label="$t('document.type')"
                                    :rules="[(v) => !!v || $t('document.typeRequired')]"></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                  <v-select :items="statusDocumentos" v-model="editedDoc.id_status_documento"
                                    item-text="descricao_status_documento" item-value="id_status_documento"
                                    :label="$t('document.status')"
                                    :rules="[(v) => !!v || $t('document.statusRequired')]"></v-select>
                                </v-col>
                                <v-col cols="12" sm="3">
                                  <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y
                                    min-width="auto" :close-on-content-click="false" :return-value.sync="dataVencimento"
                                    :rules="[validaCampo]">
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field v-model="dataFormat" :label="$t('document.expiryDate')"
                                        prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="dataVencimento" no-title scrollable locale="pt"
                                      :min="today">
                                      <v-spacer></v-spacer>
                                      <v-btn text color="primary" @click="menu = false">
                                        {{ $t('button.cancel') }}
                                      </v-btn>
                                      <v-btn text color="primary" @click="$refs.menu.save(dataVencimento)">
                                        {{ $t('button.validate') }}
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="12" sm="3">
                                  <v-file-input show-size accept="image/png, image/jpeg, pdf"
                                    :label="$t('document.selectFile')" v-model="arquivoImg"
                                    @change="fileChanged"></v-file-input>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary darken-1" class="white--text" @click="closeDoc">{{ $t('button.cancel')
                            }}</v-btn>
                          <v-btn color="primary darken-1" class="white--text" @click="saveDoc">{{ $t('button.save')
                            }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" color="blue" @click="downloadDocumento(item)"
                    :disabled="item.doc_uri === null">mdi-download</v-icon>
                  <v-icon small class="mr-2" color="green" @click="editDocumento(item)">mdi-pencil</v-icon>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="closeDocumentosDialog">{{ $t('button.close') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <ResultDialogZIP :show="zipResultDialog" :result="zipResult" :token="token" @close="closeZipResultDialog" />

    <merus-data-table :headers="headers" :items="veiculos" :mostrar-inativos="mostrarInativos" :loading="loadingVeiculos" :default-multi-sort="defaultSort"
      :loading-text="$t('crudVeiculos.loadingVehicles')" @update:displayedItems="displayedItemsForExport = $event"

 cod-tabela="VEICULOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('crudVeiculos.title')" :token="token" :items="displayedItemsForExport !== null ? displayedItemsForExport : veiculosFiltrados" :csv-title="$t('crudVeiculos.title')"
          :csv-headers="headersCSV" :pdf-title="$t('crudVeiculos.title')" :pdf-headers="headers" :pdf-filename="$t('crudVeiculos.title')"
          :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$tc('vehicle.self', 2)"
          :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvveiculos/' : null" hide-search @saveBulk="saveBulk">
          <template v-slot:extension>
            <v-switch
              v-model="mostrarInativos"
              :label="$t('crudVeiculos.showInactive')"
              class="ml-3 mr-4"
              hide-details
            ></v-switch>
            <UploadDialog :token="token" :title="$t('crudVeiculos.uploadDialog.title')" :endpoint="'/api/v1.0/insertdocumentoveiculozip'" :user="user.id_usuario"
              fileType="zip" size="s" @done="handleDone" @error="handleError" />
          </template>
          <template v-slot:add v-if="canInsert">
            <v-dialog v-model="dialog" fullscreen max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('crudVeiculos.messages.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-autocomplete v-model="editedItem.id_empresa" :items="empresas" item-text="razao_social"
                            item-value="id_empresa" clearable :label="$t('crudVeiculos.fields.selectCompany')"
                            :rules="[(v) => !!v || $t('crudVeiculos.validation.companyRequired')]"
                            :disabled="isScopedClienteCreateLock"
                            @change="filtroEmpresaChanged"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-autocomplete v-model="editedItem.id_cliente" :items="clientesPorEmpresa(editedItem.id_empresa)"
                            item-text="nome_cliente" item-value="id_cliente" clearable
                            :label="$t('crudVeiculos.fields.selectClient')"
                            :disabled="isScopedClienteCreateLock || !editedItem.id_empresa"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <LazySelect
                            ref="unidadeSelect"
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('crudVeiculos.fields.unidades')"
                            @input="onUnidadeSelect"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.numero_ordem" :label="$t('crudVeiculos.fields.numeroOrdem')"
                            :rules="[numeroOrdemRules]"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.cod_veiculo"
                            :label="$t('crudVeiculos.fields.codigoVeiculo')" :rules="[codVeiculoRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.placa" :label="$t('crudVeiculos.fields.placa')"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-select v-model="tipoVeiculo" :label="$t('crudVeiculos.fields.tipoVeiculo')"
                            :items="tiposVeiculos" return-object item-text="descricao_tipo_veiculo"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="2">
                          <v-text-field v-model="editedItem.lotacao" :label="$t('crudVeiculos.fields.lotacao')" min="0"
                            type="number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="1">
                          <!-- <v-text-field v-model="editedItem.ativo" :label="$t('crudVeiculos.fields.ativo')"></v-text-field> -->
                          <v-switch v-model="isAtivo" class="ma-2" :label="$t('crudVeiculos.fields.ativo')"></v-switch>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.chassi" :label="$t('crudVeiculos.fields.chassi')"
                            :rules="[chassiRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.modelo"
                            :label="$t('crudVeiculos.fields.modelo')"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.ano_fabricacao"
                            :label="$t('crudVeiculos.fields.anoFabricacao')" :rules="[anoRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field v-model="editedItem.ano_modelo" :label="$t('crudVeiculos.fields.anoModelo')"
                            :rules="[anoRules]"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="4">
                          <v-text-field v-model="editedItem.renavam" :label="$t('crudVeiculos.fields.renavam')"
                            :rules="[renavamRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="4">
                          <v-text-field v-model="editedItem.numero_vin" :label="$t('crudVeiculos.fields.numeroVin')"
                            :rules="[numeroVinRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                          <v-datetime-picker :label="$t('crudVeiculos.fields.dataUltimaInspecao')" v-model="dtinspecao"
                            :time-picker-props="timeProps" :text-field-props="{ prependIcon: 'mdi-calendar' }"
                            time-format="HH:mm:ss" date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                              <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                              <v-icon>mdi-clock</v-icon>
                            </template>
                          </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="12" md="4">
                        <v-select
                          v-model="editedItem.id_rastreador_principal"
                          :label="$t('crudVeiculos.fields.mainTraker')"
                          :items="fabricantesRastreador"
                          item-text="descricao_fabricante_rastreador"
                          item-value="id_fabricante_rastreador"
                          :rules="[(v) => !!v || $t('crudVeiculos.validation.mainTrakerRequired')]"
                        ></v-select>
                      </v-col>
                    </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="3">
                          <v-checkbox v-model="alocarEmLinha"
                            :label="$t('crudVeiculos.fields.alocarEmLinha')"></v-checkbox>
                        </v-col>
                        <v-col cols="8" sm="4" md="3">
                          <LazySelect
                            ref="linhaAlocadaSelect"
                            get-url="getLinhaslazy"
                            text="nome_linha"
                            value="id_linha"
                            :label="$t('crudVeiculos.fields.linha')"
                            :disabled="!alocarEmLinha"
                            @input="onLinhaAlocadaSelect"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" v-if="setup.has_validador == 1">
                          <v-text-field v-model="editedItem.cod_integracao"
                            :label="$t('crudVeiculos.fields.codigoIntegracaoProdata')"
                            :rules="[codIntegracaoRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" v-if="setup.has_queclink == 1">
                          <v-text-field v-model="editedItem.cod_integracao_queclink"
                            :label="$t('crudVeiculos.fields.codigoIntegracaoQueclink')"
                            :rules="[codIntegracaoRules]"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="setup.has_detro == 1">
                        <v-col cols="12" sm="4" md="5">
                          <v-text-field v-model="editedItem.numero_detro"
                            :label="$t('crudVeiculos.fields.numeroDetro') + ' *'" :rules="[numeroDetroRules]"
                            :disabled="!enviaDetro" @keyup="formatNumeroDetro"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="1">
                          <v-switch v-model="enviaDetro" class="ma-2" :label="$t('crudVeiculos.fields.enviaDetro')"
                            color="#4a4a4a" @change="enviaDetroToggled"></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="blue" @click="openDocumentosDialog(item)">mdi-file</v-icon>
        <v-tooltip v-if="canReadVigenciasHodometro" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="mr-2" color="purple" v-bind="attrs" v-on="on"
              @click="openVigenciasHodometro(item)">mdi-speedometer</v-icon>
          </template>
          <span>{{ $t('crudVeiculos.odometerValidity.action') }}</span>
        </v-tooltip>
        <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="item.ativo === 0 || !canDelete">mdi-delete</v-icon>
      </template>
    </merus-data-table>

    <VigenciasHodometroDialog v-model="vigenciasHodometroDialog" :veiculo="veiculoVigenciasHodometro"
      :can-edit="canEditVigenciasHodometro" :can-delete="canDeleteVigenciasHodometro" />
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import DateUtils from "../utils/dateutils";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import UploadDialog from "./Dialogs/UploadDialog.vue";
import ResultDialogZIP from "./Dialogs/ResultDialogZIP.vue";
import LazySelect from "./Selects/LazySelect.vue";
import VigenciasHodometroDialog from "./Veiculos/VigenciasHodometroDialog.vue";
import EventBus from "../utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";

export default {
  components: {
    CadastroToolbar,
    MerusDataTable,
    UploadDialog,
    ResultDialogZIP,
    LazySelect,
    VigenciasHodometroDialog,
  },
  data: () => ({
    headers: [],
    mostrarInativos: false,
    user: null,
    token: null,
    isUrbano: true,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    isAtivo: true,
    confirmDialog: false,
    mensagemdialog: "",
    disableModelo: true,
    loadingVeiculos: true,
    uploadResultDialog: false,
    zipResultDialog: false,
    zipResult: null,
    enviaDetro: false,
    tiposVeiculos: [],
    veiculos: [],
    displayedItemsForExport: null,
    empresas: [],
    equipamentos: [],
    filteredEquipamentos: [],
    documentosVeiculo: [],
    documentosDialog: false,
    clientes: [],
    scopedClienteCreateLocked: false,
    linhasAlocada: null,
    alocarEmLinha: false,
    editedIndex: -1,
    tipoVeiculo: null,
    editedItem: {
      numero_ordem: null,
      placa: null,
      id_empresa: null,
      razao_social: null,
      ativo: null,
      ativo_extenso: null,
      id_veiculo: null,
      lat: null,
      lng: null,
      rumo: null,
      velocidade: null,
      dt_ultima_posicao: null,
      cod_integracao: null,
      cod_veiculo: null,
      id_equipamento: null,
      cod_equipamento: null,
      envia_detro: null,
      envia_detro_extenso: null,
      numero_detro: null,
      lotacao: null,
      id_tipo_veiculo: null,
      descricao_tipo_veiculo: null,
      chassi: null,
      dt_ultima_inspecao: null,
      modelo: null,
      ano_modelo: null,
      ano_fabricacao: null,
      fabricante: null,
      renavam: null,
      id_linha_guia: null,
      cod_linha_guia: null,
      nome_linha_guia: null,
      cod_integracao_queclink: null,
      id_rastreador_principal: null,
      id_unidade: null,
      id_cliente: null,
      cod_cliente: null,
    },
    deletedItem: {
      numero_ordem: null,
      placa: null,
      id_empresa: null,
      razao_social: null,
      ativo: null,
      ativo_extenso: null,
      id_veiculo: null,
      lat: null,
      lng: null,
      rumo: null,
      velocidade: null,
      dt_ultima_posicao: null,
      cod_integracao: null,
      cod_veiculo: null,
      id_equipamento: null,
      cod_equipamento: null,
      envia_detro: null,
      envia_detro_extenso: null,
      numero_detro: null,
      lotacao: null,
      id_tipo_veiculo: null,
      descricao_tipo_veiculo: null,
      chassi: null,
      dt_ultima_inspecao: null,
      modelo: null,
      ano_modelo: null,
      ano_fabricacao: null,
      fabricante: null,
      renavam: null,
      id_linha_guia: null,
      cod_linha_guia: null,
      nome_linha_guia: null,
      cod_integracao_queclink: null,
      id_rastreador_principal: null,
      id_unidade: null,
      id_cliente: null,
      cod_cliente: null,
    },
    defaultItem: {
      numero_ordem: null,
      placa: null,
      id_empresa: null,
      razao_social: null,
      ativo: null,
      ativo_extenso: null,
      id_veiculo: null,
      lat: null,
      lng: null,
      rumo: null,
      velocidade: null,
      dt_ultima_posicao: null,
      cod_integracao: null,
      cod_veiculo: null,
      id_equipamento: null,
      cod_equipamento: null,
      envia_detro: null,
      envia_detro_extenso: null,
      numero_detro: null,
      id_linha_guia: null,
      cod_linha_guia: null,
      nome_linha_guia: null,
      lotacao: null,
      id_tipo_veiculo: null,
      descricao_tipo_veiculo: null,
      chassi: null,
      dt_ultima_inspecao: null,
      modelo: null,
      ano_modelo: null,
      ano_fabricacao: null,
      fabricante: null,
      renavam: null,
      cod_integracao_queclink: null,
      id_rastreador_principal: null,
      id_unidade: null,
      id_cliente: null,
      cod_cliente: null,
    },
    addDocDialog: false,
    formDocValidado: false,
    editedIndexDoc: -1,
    editedDoc: {
      id_veiculo: null,
      id_status_documento: null,
      id_tipo_documento: null,
      doc_uri: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
      dt_inclusao: null,
      dt_inclusao_extenso: null,
      dt_ultima_alteracao: null,
      dt_ultima_alteracao_extenso: null,
      dt_vencimento: null,
      dt_vencimento_extenso: null,
      descricao_status_documento: null,
      cod_tipo_documento: null,
      usuario_inclusao: null,
      usuario_alteracao: null
    },
    defaultDoc: {
      id_veiculo: null,
      id_status_documento: null,
      id_tipo_documento: null,
      doc_uri: null,
      id_usuario_inclusao: null,
      id_usuario_ultima_alteracao: null,
      dt_inclusao: null,
      dt_inclusao_extenso: null,
      dt_ultima_alteracao: null,
      dt_ultima_alteracao_extenso: null,
      dt_vencimento: null,
      dt_vencimento_extenso: null,
      descricao_status_documento: null,
      cod_tipo_documento: null,
      usuario_inclusao: null,
      usuario_alteracao: null
    },
    menu: false,
    dataVencimento: null,
    arquivoImg: null,
    tiposDocumentos: [],
    statusDocumentos: [],
    docimg: null,
    timeProps: {
      useSeconds: true,
    },
    dtinspecao: null,
    recursos: [],
    empresasPermitidas: [],
    fabricantesRastreador: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    // Vigências de hodômetro virtual: diálogo próprio, gravado fora do save do veículo.
    canReadVigenciasHodometro: false,
    canEditVigenciasHodometro: false,
    canDeleteVigenciasHodometro: false,
    vigenciasHodometroDialog: false,
    veiculoVigenciasHodometro: null,
    setup: {
      has_subsidio: 0,
      has_validador: 0,
      has_queclink: 0,
      has_detro: 0,
    }
  }),
  computed: {
    messageDismissButton() { return this.$t('button.dismiss') },
    messageConfirmButton() { return this.$t('button.confirm') },
    defaultSort() {
      return [
        { value: 'ativa_extenso', options: { text: this.$t('crudUnidades.sortOptions.descending'), value: -1 } },
        { value: 'cod_veiculo', options: { text: this.$t('crudUnidades.sortOptions.ascending'), value: 1 } }]
    },
    veiculosFiltrados() {
      if (!this.mostrarInativos) {
        return this.veiculos.filter((veiculo) => {
          return veiculo.ativo === true || veiculo.ativo === 1;
        });
      }
      return this.veiculos;
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('crudVeiculos.formTitle.create') : this.$t('crudVeiculos.formTitle.edit');
    },
    formTitleDoc() {
      return this.editedIndexDoc === -1
        ? this.$t('crudVeiculos.formTitleDoc.create')
        : this.$t('crudVeiculos.formTitleDoc.edit');
    },
    today() {
      return new Date().toISOString();
    },
    dataFormat() {
      if (!this.dataVencimento) return null;
      const [ano, mes, dia] = this.dataVencimento.split('-');
      return `${dia}/${mes}/${ano}`;
    },
    tipoDocumentoDisabled() {
      return this.editedIndexDoc !== -1;
    },
    headersCSV() {
      return [
        { text: this.$t('crudVeiculos.csvHeaders.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$t('crudVeiculos.csvHeaders.operacao'), value: "operacao" },
        { text: this.$t('crudVeiculos.csvHeaders.empresa'), value: "cod_empresa", error: "error_empresa" },
        { text: this.$t('crudVeiculos.csvHeaders.cliente'), value: "cod_cliente", error: "error_cliente" },
        { text: this.$t('crudVeiculos.csvHeaders.unidades'), value: "cod_unidade", error: "error_unidade" },
        { text: this.$t('crudVeiculos.csvHeaders.codigoVeiculo'), value: "cod_veiculo", error: "error_cod" },
        { text: this.$t('crudVeiculos.csvHeaders.numeroOrdem'), value: "numero_ordem", error: "error_numero_ordem" },
        { text: this.$t('crudVeiculos.csvHeaders.codigoIntegracao'), value: "cod_integracao", error: "error_cod_integracao" },
        { text: this.$t('crudVeiculos.csvHeaders.placa'), value: "placa", error: "error_placa" },
        { text: this.$t('crudVeiculos.csvHeaders.ativo'), value: "ativo", error: "error_ativo" },
        { text: this.$t('crudVeiculos.csvHeaders.enviaDetro'), value: "envia_detro", error: "error_envia_detro" },
        { text: this.$t('crudVeiculos.csvHeaders.numeroDetro'), value: "numero_detro", error: "error_numero_detro" },
        { text: this.$t('crudVeiculos.csvHeaders.lotacao'), value: "lotacao", error: "error_lotacao" },
        { text: this.$t('crudVeiculos.csvHeaders.tipo'), value: "descricao_tipo_veiculo", error: "error_tipo_veiculo" },
        { text: this.$t('crudVeiculos.csvHeaders.chassi'), value: "chassi", error: "error_chassi" },
        { text: this.$t('crudVeiculos.csvHeaders.modelo'), value: "modelo", error: "error_modelo" },
        { text: this.$t('crudVeiculos.csvHeaders.fabricacao'), value: "ano_fabricacao", error: "error_ano_fabricacao" },
        { text: this.$t('crudVeiculos.csvHeaders.anoModelo'), value: "ano_modelo", error: "error_ano_modelo" },
        { text: this.$t('crudVeiculos.csvHeaders.renavam'), value: "renavam", error: "error_renavam" },
        { text: this.$t('crudVeiculos.csvHeaders.ultimaInspecao'), value: "dt_ultima_inspecao", error: "error_dt_ultima_inspecao", warning: "warning_dt_ultima_inspecao" },
        { text: this.$t('crudVeiculos.csvHeaders.numeroVin'), value: "numero_vin", error: "error_numero_vin" },
        { text: this.$t('crudVeiculos.csvHeaders.codLinha'), value: "cod_linha_guia", error: "error_cod_linha_guia" }];
    },
    headersDocumentos() {
      return [
        { text: this.$t('document.type'), value: "cod_tipo_documento", sortable: true },
        { text: this.$t('document.status'), value: "descricao_status_documento", sortable: true },
        { text: this.$t('document.expiryDate'), value: "dt_vencimento_extenso", sortable: true },
        { text: this.$t('document.includedBy'), value: "usuario_inclusao", sortable: true },
        { text: this.$t('document.modifiedBy'), value: "usuario_alteracao", sortable: true },
        { text: this.$t('document.actions'), value: "actions", sortable: false }];
    },
    helpCSV() {
      return [
        {
          label: this.$t('crudVeiculos.helpCSV.companyCode.label'),
          description: this.$t('crudVeiculos.helpCSV.companyCode.description'),
          example: this.$t('crudVeiculos.helpCSV.companyCode.example'),
          key: "cod_empresa"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.vehicleCode.label'),
          description: this.$t('crudVeiculos.helpCSV.vehicleCode.description'),
          example: this.$t('crudVeiculos.helpCSV.vehicleCode.example'),
          key: "cod_veiculo"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.orderNumber.label'),
          description: this.$t('crudVeiculos.helpCSV.orderNumber.description'),
          example: this.$t('crudVeiculos.helpCSV.orderNumber.example'),
          key: "numero_ordem"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.integrationCode.label'),
          description: this.$t('crudVeiculos.helpCSV.integrationCode.description'),
          example: this.$t('crudVeiculos.helpCSV.integrationCode.example'),
          key: "cod_integracao"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.plate.label'),
          description: this.$t('crudVeiculos.helpCSV.plate.description'),
          example: this.$t('crudVeiculos.helpCSV.plate.example'),
          key: "placa"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.active.label'),
          description: this.$t('crudVeiculos.helpCSV.active.description'),
          example: this.$t('crudVeiculos.helpCSV.active.example'),
          key: "ativo"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.sendDetro.label'),
          description: this.$t('crudVeiculos.helpCSV.sendDetro.description'),
          example: this.$t('crudVeiculos.helpCSV.sendDetro.example'),
          key: "envia_detro"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.detroNumber.label'),
          description: this.$t('crudVeiculos.helpCSV.detroNumber.description'),
          example: this.$t('crudVeiculos.helpCSV.detroNumber.example'),
          key: "numero_detro"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.capacity.label'),
          description: this.$t('crudVeiculos.helpCSV.capacity.description'),
          example: this.$t('crudVeiculos.helpCSV.capacity.example'),
          key: "lotacao"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.vehicleType.label'),
          description: this.$t('crudVeiculos.helpCSV.vehicleType.description'),
          example: this.$t('crudVeiculos.helpCSV.vehicleType.example'),
          key: "descricao_tipo_veiculo"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.chassis.label'),
          description: this.$t('crudVeiculos.helpCSV.chassis.description'),
          example: this.$t('crudVeiculos.helpCSV.chassis.example'),
          key: "chassi"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.model.label'),
          description: this.$t('crudVeiculos.helpCSV.model.description'),
          example: this.$t('crudVeiculos.helpCSV.model.example'),
          key: "modelo"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.manufacturingYear.label'),
          description: this.$t('crudVeiculos.helpCSV.manufacturingYear.description'),
          example: this.$t('crudVeiculos.helpCSV.manufacturingYear.example'),
          key: "ano_fabricacao"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.modelYear.label'),
          description: this.$t('crudVeiculos.helpCSV.modelYear.description'),
          example: this.$t('crudVeiculos.helpCSV.modelYear.example'),
          key: "ano_modelo"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.renavam.label'),
          description: this.$t('crudVeiculos.helpCSV.renavam.description'),
          example: this.$t('crudVeiculos.helpCSV.renavam.example'),
          key: "renavam"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.lastInspectionDate.label'),
          description: this.$t('crudVeiculos.helpCSV.lastInspectionDate.description'),
          example: this.$t('crudVeiculos.helpCSV.lastInspectionDate.example'),
          key: "dt_ultima_inspecao"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.numeroVin.label'),
          description: this.$t('crudVeiculos.helpCSV.numeroVin.description'),
          example: this.$t('crudVeiculos.helpCSV.numeroVin.example'),
          key: "numero_vin"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.codLinha.label'),
          description: this.$t('crudVeiculos.helpCSV.codLinha.description'),
          example: this.$t('crudVeiculos.helpCSV.codLinha.example'),
          key: "cod_linha_guia"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.clientCode.label'),
          description: this.$t('crudVeiculos.helpCSV.clientCode.description'),
          example: this.$t('crudVeiculos.helpCSV.clientCode.example'),
          key: "cod_cliente"
        },
        {
          label: this.$t('crudVeiculos.helpCSV.unidades.label'),
          description: this.$t('crudVeiculos.helpCSV.unidades.description'),
          example: this.$t('crudVeiculos.helpCSV.unidades.example'),
          key: "cod_unidade"
        }];
    },
    isScopedClienteCreateLock() {
      return this.editedIndex === -1 && this.scopedClienteCreateLocked;
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.editedIndex === -1) {
            this.applyScopedClienteEmpresaOnCreate();
            this.applySingleEmpresaIfOnlyOption();
          }
          this.syncUnidadeSelect();
        });
      }
      val || this.close();
    },
    clientes() {
      if (this.dialog && this.editedIndex === -1) {
        this.applyScopedClienteEmpresaOnCreate();
        this.applySingleEmpresaIfOnlyOption();
      }
    },
    empresas() {
      if (this.dialog && this.editedIndex === -1) {
        this.$nextTick(() => {
          this.applyScopedClienteEmpresaOnCreate();
          this.applySingleEmpresaIfOnlyOption();
        });
      }
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (this.$refs.formDoc) {
        this.$refs.formDoc.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
  },
  mounted() { },
  methods: {

    validaCampo() {
      return true;
    },
    initialize() {
      this.populaRecursos();
      this.populaSetup();
      this.populaTiposVeiculos();
      this.populaEmpresas();
      this.populaEquipamentos();
      this.populaTiposDocumentos();
      this.populaStatusDocumentos();
      this.populaClientes();
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.setup = response.data[0];
        },
      });
    },
    filterVeiculosPorPerfilCliente(permitted) {
      return permitted;
      // const u = this.user;
      // if (!u) {
      //   return [];
      // }
      // if (u.is_superadmin === 1 || Number(u.is_administrador) === 1 || u.is_administrador === true) {
      //   return permitted;
      // }
      // if (u.id_cliente == null) {
      //   return [];
      // }
      // return permitted.filter((v) => {
      //   if (v.id_cliente != null) {
      //     return v.id_cliente === u.id_cliente;
      //   }
      //   if (u.id_empresa_cliente == null) {
      //     return false;
      //   }
      //   return v.id_empresa === u.id_empresa_cliente;
      // });
    },
    filterLinhasPorPerfilCliente(permitted) {
      const u = this.user;
      if (!u) {
        return [];
      }
      if (u.is_superadmin === 1 || Number(u.is_administrador) === 1 || u.is_administrador === true) {
        return permitted;
      }
      if (u.id_cliente == null) {
        return [];
      }
      return permitted.filter((l) => {
        if (l.id_cliente != null) {
          return l.id_cliente === u.id_cliente;
        }
        if (u.id_empresa_cliente == null) {
          return false;
        }
        return l.id_empresa === u.id_empresa_cliente;
      });
    },
    clientesPorEmpresa(idEmpresa) {
      if (idEmpresa == null) {
        return [];
      }
      return this.clientes.filter((c) => c.id_empresa === idEmpresa);
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculoscrud, {
        onSuccess: (response) => {
          if (Array.isArray(response.data)) {
            const resposta = response.data;
            this.veiculos = resposta
              .map(veiculo => {
                const translated = translateDbField(
                  veiculo.translation_key,
                  veiculo.descricao_tipo_veiculo
                );
                return {
                  ...veiculo,
                  descricao_tipo_veiculo: translated,
                  descricao_unidade: veiculo.descricao_unidade_efetiva || veiculo.descricao_unidade || 'Sem Unidade',
                  ativo_extenso: veiculo.ativo === 1 ? this.$t('system.yes') : this.$t('system.no'),
                  envia_detro_extenso: veiculo.envia_detro === 1 ? this.$t('system.yes') : this.$t('system.no'),
                  autorizado_prefeitura_extenso: veiculo.autorizado_prefeitura === 1 ? this.$t('system.yes') : this.$t('system.no')
                };
              });
          } else {
            console.error("Expected array but got:", typeof response.data, response.data);
            this.veiculos = [];
          }
          this.loadingVeiculos = false;
          this.openFromRouteQuery();
        },
        onError: () => {
          this.loadingVeiculos = false;
        },
      });
    },
    openFromRouteQuery() {
      const id = this.$route && this.$route.query ? this.$route.query.id_veiculo : null;
      if (id == null || id === '') return;
      const item = (this.veiculos || []).find((v) => String(v.id_veiculo) === String(id));
      if (!item) return;
      this.$nextTick(() => this.editItem(item));
    },
    onLinhaAlocadaSelect(val) {
      if (val == null || val === '') {
        this.linhasAlocada = null;
        return;
      }
      const ref = this.$refs.linhaAlocadaSelect;
      const cached =
        ref && typeof ref.getCachedSelectedItem === 'function'
          ? ref.getCachedSelectedItem(val)
          : null;
      this.linhasAlocada = cached || { id_linha: val };
    },
    /** Semeia o select lazy com a linha ja alocada ao veiculo (o registro traz codigo e nome). */
    syncLinhaAlocadaSelect() {
      const ref = this.$refs.linhaAlocadaSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_linha_guia;
      if (id != null && id !== '' && this.alocarEmLinha) {
        const item = {
          id_linha: id,
          cod_linha: this.editedItem.cod_linha_guia,
          nome_linha: this.editedItem.nome_linha_guia,
        };
        this.linhasAlocada = item;
        ref.cacheSelectedItems([item], 'id_linha');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    populaClientes() {
      apiController.request(apiController.endpoints.getallClientes, {
        onSuccess: (response) => {
          this.clientes = Array.isArray(response.data) ? response.data : [];
        },
        onError: () => {
          this.clientes = [];
        },
      });
    },
    populaFabricantesRastreador() {
      apiController.request(apiController.endpoints.getallFabricantesrastreador, {
        silent: true,
        onSuccess: (response) => {
          this.fabricantesRastreador = response.data;
          this.fabricantesRastreador.forEach(fabricante => {
            const translated = translateDbField(
              fabricante.translation_key,
              fabricante.descricao_fabricante_rastreador
            );
            fabricante.descricao_fabricante_rastreador = translated;
            return fabricante;
          });
        },
      });
    },
    populaEmpresasPermitidas() {
      this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
        return rec.id_empresa
      });
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = Array.isArray(response.data) ? response.data : [];
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.canReadVigenciasHodometro = true;
            this.canEditVigenciasHodometro = true;
            this.canDeleteVigenciasHodometro = true;
            this.populaEmpresasPermitidas();
            this.populaVeiculos();
            this.populaFabricantesRastreador();
          },
          onError: () => {
            this.recursos = [];
            this.empresasPermitidas = [];
            this.veiculos = [];
            this.loadingVeiculos = false;
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = Array.isArray(response.data) ? response.data : [];
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateveiculo");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertveiculo");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteveiculo");
            this.canReadVigenciasHodometro = this.recursos.some((r) => r.rota === "/api/v1.0/getvigenciashodometroveiculo");
            this.canEditVigenciasHodometro = this.recursos.some((r) => r.rota === "/api/v1.0/insertvigenciahodometroveiculo" || r.rota === "/api/v1.0/updatevigenciahodometroveiculo");
            this.canDeleteVigenciasHodometro = this.recursos.some((r) => r.rota === "/api/v1.0/deletevigenciahodometroveiculo");
            this.populaEmpresasPermitidas();
            this.populaVeiculos();
            this.populaFabricantesRastreador();
          },
          onError: () => {
            this.recursos = [];
            this.empresasPermitidas = [];
            this.veiculos = [];
            this.loadingVeiculos = false;
          },
        });
      }
    },
    populaTiposVeiculos() {
      apiController.request(apiController.endpoints.getallTiposveiculos, {
        onSuccess: (response) => {
          // Ensure tiposVeiculos is always an array
          if (Array.isArray(response.data)) {
            this.tiposVeiculos = response.data.map(tipoVeiculo => {
              const translated = translateDbField(
                tipoVeiculo.translation_key,
                tipoVeiculo.descricao_tipo_veiculo
              );
              return {
                ...tipoVeiculo,
                descricao_tipo_veiculo: translated
              };
            });
          } else if (response.data && typeof response.data === 'object') {
            // If response.data is an object, try to convert it to array
            // Check if it has a data or items property
            if (Array.isArray(response.data.data)) {
              this.tiposVeiculos = response.data.data;
            } else if (Array.isArray(response.data.items)) {
              this.tiposVeiculos = response.data.items;
            } else {
              // Convert object values to array if it's a plain object
              this.tiposVeiculos = Object.values(response.data);
            }
          } else {
            this.tiposVeiculos = [];
          }
        },
        onError: () => {
          // Ensure tiposVeiculos is always an array even on error
          this.tiposVeiculos = [];
        },
      });
    },
    closeUploadDialog() {
      this.$refs.form.resetValidation();
      this.idempresaupload = null;
      this.arquivoCsv = null;
      this.arquivoLog = null;
      this.resultCSV = [];
      this.uploadDialog = false;
    },
    // filtraLinhas() {
    //   this.filteredLinhas = this.linhas.filter((element) => {
    //     return element.id_empresa == this.editedItem.id_empresa;
    //   });
    // },
    filtraEquipamentos() {
      // O backend já devolve o escopo correto para a tela de veículos.
      this.filteredEquipamentos = Array.isArray(this.equipamentos) ? this.equipamentos.slice() : [];
    },
    filtroEmpresaChanged() {
      // this.filtraLinhas();
      this.filtraEquipamentos();
      if (this.editedItem.id_cliente != null) {
        const stillValid = this.clientes.some(
          (c) => c.id_cliente === this.editedItem.id_cliente && c.id_empresa === this.editedItem.id_empresa
        );
        if (!stillValid) {
          this.editedItem.id_cliente = null;
        }
      }
    },
    applyScopedClienteEmpresaOnCreate() {
      this.scopedClienteCreateLocked = false;
      if (this.editedIndex !== -1 || !shouldLockClienteOnCreate()) {
        return;
      }
      const id = getScopedClienteIdForCreate();
      if (id == null) {
        return;
      }
      const c = this.clientes.find((x) => Number(x.id_cliente) === Number(id));
      if (!c || c.id_empresa == null) {
        return;
      }
      this.editedItem.id_cliente = id;
      this.editedItem.id_empresa = c.id_empresa;
      this.scopedClienteCreateLocked = true;
      this.filtroEmpresaChanged();
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.editedIndex !== -1) {
        return;
      }
      if (this.scopedClienteCreateLocked) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
      this.filtroEmpresaChanged();
    },
    showUploadDialog() {
      this.arquivoCsv = null;
      this.fimProcesso = false;
      this.mensagemUpload = null;
      this.fileLoading = false;
      this.uploadDialog = true;
    },
    // placaRules() {
    //   if (!this.editedItem.placa) return true;

    //   if (!/[A-Z]{3}[0-9][0-9A-Z][0-9]{2}$/.test(this.editedItem.placa)) {
    //     return this.$t('crudVeiculos.validation.placaInvalid');
    //   } else {
    //     return true;
    //   }
    // },
    numeroDetroRules() {
      if (!this.enviaDetro) {
        return true;
      }

      if (!this.editedItem.numero_detro) {
        return this.$t('crudVeiculos.validation.numeroDetroRequired');
      }

      if (this.editedItem.numero_detro.length > 15) {
        return this.$t('crudVeiculos.validation.numeroDetroMaxLength');
      }

      return true;
    },
    codVeiculoRules() {
      if (!validador(this.editedItem.cod_veiculo, 1, 30, 0, 1)) {
        return this.$t('crudVeiculos.validation.codigoVeiculoRequired');
      } else {
        return true;
      }
    },
    codIntegracaoRules() {
      if (!validador(this.editedItem.cod_integracao, 1, 30, 0, 0)) {
        return this.$t('crudVeiculos.validation.codigoIntegracaoInvalid');
      } else {
        return true;
      }
    },
    numeroOrdemRules() {
      if (!validador(this.editedItem.numero_ordem, 1, 30, 0, 1)) {
        return this.$t('crudVeiculos.validation.numeroOrdemRequired');
      } else {
        return true;
      }
    },
    submitFile() {
      this.$refs.form.validate();
      if (this.formValidado) {
        let formData = new FormData();

        this.mensagemUpload = "Loading File";
        this.fileLoading = true;
        if (this.arquivoCsv) {
          formData.append("arquivocsv", this.arquivoCsv);
          apiController.request(apiController.endpoints.uploadCsv, {
            data: formData,
            onSuccess: () => {
              this.processaArquivo();
            },
            onError: () => {
              this.fileLoading = false;
            },
          });
        } else {
          console.log("there are no files.");
        }
      }
    },
    processaArquivo() {
      this.mensagemUpload = "Processing File";
      apiController.request(apiController.endpoints.processaCsvveiculos, {
        params: { file: this.arquivoCsv.name },
        onSuccess: (response) => {
          this.mensagemUpload = response.data.error ? "Error Processing File" : "File Processed Successfully";
          this.fileLoading = false;
          this.fimProcesso = true;
          this.arquivoLog = response.data.arqlog;
          this.resultCSV = response.data.result;
          this.showSaveButton = !response.data.error;
          this.uploadResultDialog = true;
        },
        onError: () => {
          this.fileLoading = false;
        },
      });
    },
    downloadArquivoLog() {
      apiController.request(apiController.endpoints.downloadLog, {
        params: { filename: this.baseName(this.arquivoLog) },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.baseName(this.arquivoLog)); //or any other extension
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    baseName(str) {
      var base = new String(str).substring(str.lastIndexOf("/") + 1);
      return base;
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          // Ensure response.data is an array
          if (Array.isArray(response.data)) {
            this.empresas = response.data;
          } else {
            console.error("Expected array but got:", typeof response.data, response.data);
            this.empresas = [];
          }
        },
        onError: () => {
          this.empresas = [];
        },
      });
    },
    populaEquipamentos() {
      apiController.request(apiController.endpoints.getallEquipamentos, {
        onSuccess: (response) => {
          this.equipamentos = response.data;
        },
      });
    },
    populaTiposDocumentos() {
      apiController.request(apiController.endpoints.getTiposdocumentosveiculos, {
        onSuccess: (response) => {
          let data = [];
          // Ensure tiposDocumentos is always an array
          if (Array.isArray(response.data)) {
            data = response.data;
          } else if (response.data && typeof response.data === 'object') {
            // If response.data is an object, try to convert it to array
            if (Array.isArray(response.data.data)) {
              data = response.data.data;
            } else if (Array.isArray(response.data.items)) {
              data = response.data.items;
            } else {
              // Convert object values to array if it's a plain object
              data = Object.values(response.data);
            }
          }
          // Apply translations
          this.tiposDocumentos = data.map((t) => ({
            ...t,
            cod_tipo_documento: translateDbField(
              t.translation_key,
              t.cod_tipo_documento
            )
          }));
        },
        onError: () => {
          // Ensure tiposDocumentos is always an array even on error
          this.tiposDocumentos = [];
        },
      });
    },
    populaStatusDocumentos() {
      apiController.request(apiController.endpoints.getallStatusdocumentos, {
        silent: true,
        onSuccess: (response) => {
          this.statusDocumentos = response.data;
          this.statusDocumentos.forEach(status => {
            status.descricao_status_documento = translateDbField(
              status.translation_key,
              status.descricao_status_documento
            );
            return status;
          });
        },
        onError: (e) => {
          console.log(e);
        },
      });
    },
    editItem(item) {
      this.scopedClienteCreateLocked = false;
      this.editedIndex = this.veiculos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      const rawUnidade =
        this.editedItem.id_unidade != null && this.editedItem.id_unidade !== ''
          ? this.editedItem.id_unidade
          : this.editedItem.id_unidade_veiculo != null && this.editedItem.id_unidade_veiculo !== ''
            ? this.editedItem.id_unidade_veiculo
            : Array.isArray(this.editedItem.unidades) && this.editedItem.unidades.length
              ? this.editedItem.unidades[0]
              : null;
      this.editedItem.id_unidade =
        rawUnidade != null && Number(rawUnidade) !== -1 && Number.isFinite(Number(rawUnidade))
          ? Number(rawUnidade)
          : null;
      this.editedItem.ano_fabricacao = this.editedItem.ano_fabricacao ? this.editedItem.ano_fabricacao.toString() : null;
      this.editedItem.ano_modelo = this.editedItem.ano_modelo ? this.editedItem.ano_modelo.toString() : null;
      // Ensure tiposVeiculos is an array before calling find
      if (Array.isArray(this.tiposVeiculos)) {
        this.tipoVeiculo = this.tiposVeiculos.find((t) => t.id_tipo_veiculo == this.editedItem.id_tipo_veiculo) || null;
      } else {
        this.tipoVeiculo = null;
      }
      if (this.editedItem.ativo == 1) {
        this.isAtivo = true;
      } else {
        this.isAtivo = false;
      }
      if (this.editedItem.envia_detro == 1) {
        this.enviaDetro = true;
      } else {
        this.enviaDetro = false;
      }

      if (this.editedItem.aloca_linha_permanente == 1) {
        this.alocarEmLinha = true;
      } else {
        this.alocarEmLinha = false;
        this.linhasAlocada = null;
      }

      this.filtroEmpresaChanged();
      this.dialog = true;
      this.$nextTick(() => {
        this.syncUnidadeSelect();
        this.syncLinhaAlocadaSelect();
      });
    },
    onUnidadeSelect(val) {
      this.editedItem.id_unidade = val != null && val !== '' ? val : null;
      const ref = this.$refs.unidadeSelect;
      const cached =
        ref && typeof ref.getCachedSelectedItem === 'function'
          ? ref.getCachedSelectedItem(val)
          : null;
      if (cached) {
        if (cached.cod_unidade != null) this.editedItem.cod_unidade = cached.cod_unidade;
        if (cached.descricao_unidade != null) {
          this.editedItem.descricao_unidade = cached.descricao_unidade;
        }
      } else if (this.editedItem.id_unidade == null) {
        this.editedItem.cod_unidade = null;
        this.editedItem.descricao_unidade = null;
      }
    },
    syncUnidadeSelect() {
      const ref = this.$refs.unidadeSelect;
      if (!ref || typeof ref.setData !== 'function') return;
      const id = this.editedItem && this.editedItem.id_unidade;
      if (id != null && id !== '') {
        ref.cacheSelectedItems([{
          id_unidade: id,
          cod_unidade: this.editedItem.cod_unidade,
          descricao_unidade:
            this.editedItem.descricao_unidade_efetiva ||
            this.editedItem.descricao_unidade ||
            String(id),
        }], 'id_unidade');
        ref.setData(id);
      } else if (typeof ref.resetData === 'function') {
        ref.resetData();
      }
      if (typeof ref.loadLazyItems === 'function') {
        ref.loadLazyItems('');
      }
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog = this.$t('crudVeiculos.messages.confirmDeactivation', {vehicleNumber: item.numero_ordem });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteVeiculo, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.scopedClienteCreateLocked = false;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.isAtivo = true;
        this.modelos = [];
        this.disableModelo = true;
        this.alocarEmLinha = false;
        this.linhasAlocada = null;
        this.tipoVeiculo = null;
        if (this.$refs.unidadeSelect && typeof this.$refs.unidadeSelect.resetData === 'function') {
          this.$refs.unidadeSelect.resetData();
        }
        if (this.$refs.linhaAlocadaSelect && typeof this.$refs.linhaAlocadaSelect.resetData === 'function') {
          this.$refs.linhaAlocadaSelect.resetData();
        }
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        if (this.isAtivo) {
          this.editedItem.ativo = 1;
        } else {
          this.editedItem.ativo = 0;
        }

        if (this.enviaDetro) {
          this.editedItem.envia_detro = 1;
        } else {
          this.editedItem.envia_detro = 0;
        }

        if (this.dtinspecao) {
          this.editedItem.dt_ultima_inspecao = DateUtils.getDateSQLFormatted(this.dtinspecao);
        }

        if (this.alocarEmLinha) {
          this.editedItem.aloca_linha_permanente = 1;
        } else {
          this.editedItem.aloca_linha_permanente = 0;
        }

        this.editedItem.razao_social = this.empresas.find((e) => e.id_empresa == this.editedItem.id_empresa)?.razao_social;
        this.editedItem.cod_equipamento = this.equipamentos.find((e) => e.id_equipamento == this.editedItem.id_equipamento)?.cod_equipamento;
        this.editedItem.id_linha_guia = this.linhasAlocada?.id_linha;
        this.editedItem.cod_linha_guia = this.linhasAlocada?.cod_linha;
        this.editedItem.nome_linha_guia = this.linhasAlocada?.nome_linha;
        this.editedItem.descricao_tipo_veiculo = this.tipoVeiculo?.descricao_tipo_veiculo;
        this.editedItem.id_tipo_veiculo = this.tipoVeiculo?.id_tipo_veiculo;
        this.editedItem.id_unidade = this.editedItem.id_unidade != null && this.editedItem.id_unidade !== ''
          ? Number(this.editedItem.id_unidade)
          : null;

        if (this.editedIndex == -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertVeiculo, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateVeiculo, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    saveBulk(veiculos) {
      let rows = Array.isArray(veiculos)
        ? veiculos
        : veiculos && Array.isArray(veiculos.items)
          ? veiculos.items
          : [];
      if (rows.length === 0) {
        return;
      }
      this.operacao = 0;
      let temp = rows.map((v) => {
        return [
          v.numero_ordem,
          v.placa,
          v.id_empresa,
          v.razao_social,
          v.ativo,
          v.cod_integracao,
          v.cod_veiculo,
          v.lotacao,
          v.descricao_tipo_veiculo,
          v.numero_detro,
          v.envia_detro,
          v.cod_integracao_queclink,
          v.id_tipo_veiculo,
          v.chassi,
          v.modelo,
          v.ano_fabricacao,
          v.ano_modelo,
          v.fabricante,
          v.renavam,
          v.dt_ultima_inspecao,
          v.numero_vin,
          v.id_linha_guia,
          v.cod_linha_guia,
          v.nome_linha_guia,
          v.id_unidade,
          v.id_cliente];
      });
      apiController.request(apiController.endpoints.insertVeiculosbulk, {
        data: temp,
        onSuccess: (response) => {
          this.uploadResultDialog = false;
          this.updateTable(response.data.erro);
        },
        onError: () => {
          this.uploadResultDialog = false;
        },
      });
    },
    updateTable(status) {
      let mensagem = "";
      let tipo = status ? "error" : "success";
      
      if (status) {
        if (this.operacao == 0) {
          mensagem = this.$t('crudVeiculos.messages.errorInsert');
        } else {
          if (this.operacao == 1) {
            mensagem = this.$t('crudVeiculos.messages.errorUpdate');
          } else {
            mensagem = this.$t('crudVeiculos.messages.errorDelete');
          }
        }
      } else {
        if (this.operacao == 0) {
          mensagem = this.$t('crudVeiculos.messages.successInsert');
        } else {
          if (this.operacao == 1) {
            mensagem = this.$t('crudVeiculos.messages.successUpdate');
          } else {
            mensagem = this.$t('crudVeiculos.messages.successDelete');
          }
        }
      }
      
      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaVeiculos();
    },
    enviaDetroToggled() {
      if (!this.enviaDetro) {
        this.editedItem.numero_detro = null;
      }
    },
    formatNumeroDetro() {
      this.editedItem.numero_detro = this.editedItem.numero_detro.toUpperCase();
    },
    openVigenciasHodometro(item) {
      this.veiculoVigenciasHodometro = item;
      this.vigenciasHodometroDialog = true;
    },
    openDocumentosDialog(item) {
      this.editedItem = Object.assign({}, item);
      this.editedIndex = this.veiculos.findIndex((f) => f.id_veiculo == item.id_veiculo);
      this.documentosDialog = true;
      this.populaDocumentosVeiculo(item.id_veiculo);
    },
    closeDocumentosDialog() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.documentosVeiculo = [];
      this.documentosDialog = false;
    },
    populaDocumentosVeiculo(idveiculo) {
      apiController.request(apiController.endpoints.getDocumentosporidveiculo, {
        params: { id: idveiculo },
        onSuccess: (response) => {
          this.documentosVeiculo = response.data.map((d) => ({
            ...d,
            cod_tipo_documento: translateDbField(
              d.translation_key,
              d.cod_tipo_documento
            )
          }));
        },
      });
    },
    editDocumento(doc) {
      this.editedIndexDoc = this.documentosVeiculo.indexOf(doc);
      this.editedDoc = Object.assign({}, doc);
      this.dataVencimento = this.editedDoc.dt_vencimento;
      this.addDocDialog = true;
    },
    downloadDocumento(doc) {
      const split = doc.doc_uri.split("/");
      apiController.request(apiController.endpoints.downloadDocumento, {
        params: { filename: split[split.length - 1] },
        config: { responseType: "blob" },
        onSuccess: (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", split[split.length - 1]); //or any other extension
          document.body.appendChild(link);
          link.click();
        },
      });
    },
    closeDoc() {
      this.arquivoImg = null;
      this.docimg = null;
      this.editedIndexDoc = -1;
      this.editedDoc = Object.assign({}, this.defaultDoc);
      this.dataVencimento = null;
      this.addDocDialog = false;
      this.$nextTick(() => {
        this.$refs.formDoc.resetValidation();
      })
    },
    fileChanged() {
      const reader = new FileReader();
      reader.onload = e => {
        this.docimg = e.target.result;
      };
      reader.readAsDataURL(this.arquivoImg);
    },
    saveDoc() {
      this.$refs.formDoc.validate()
      if (this.formDocValidado) {
        this.editedDoc.dt_vencimento = this.dataVencimento;
        this.editedDoc.id_veiculo = this.editedItem.id_veiculo;
        if (this.editedIndexDoc === -1) {
          this.editedDoc.id_usuario_inclusao = this.user.id_usuario;
        } else {
          this.editedDoc.id_usuario_ultima_alteracao = this.user.id_usuario;
          this.editedDoc.dt_ultima_alteracao = DateUtils.getDateSQLFormatted(new Date());
        }

        if (this.arquivoImg) {
          let payload = {
            file: this.docimg,
            folder: "documentos",
            filename: this.arquivoImg.name.replace(".png", "").replace(".jpeg", "").replace(".jpg", "").replace(".pdf", "")
          }

          console.log(payload)
          apiController.request(apiController.endpoints.uploadImg, {
            data: payload,
            silent: true,
            onSuccess: (response) => {
              console.log(response.data);
              if (!response.data.erro) {
                this.editedDoc.doc_uri = response.data.path;
              }
              this.saveOnDatabase();
            },
            onError: (e) => {
              console.log(e);
              this.saveOnDatabase();
            },
          });
        } else {
          this.saveOnDatabase();
        }
      }
    },
    saveOnDatabase() {
      apiController.request(apiController.endpoints.insertDocumentoveiculo, {
        data: this.editedDoc,
        onSuccess: (response) => {
          console.log(response.data);
          this.populaDocumentosVeiculo(this.editedItem.id_veiculo);
          this.closeDoc();
        },
        onError: () => {
          this.closeDoc();
        },
      });
    },
    chassiRules() {
      return true;
    },
    anoRules(v) {
      if (!v) {
        return true;
      }

      if (v.length !== 4) {
        return this.$t('crudVeiculos.validation.anoFormat');
      }

      return true;
    },
    renavamRules(v) {
      if (!v) {
        return true;
      }

      if (v.length > 11) {
        return this.$t('crudVeiculos.validation.renavamMaxLength');
      }

      return true;
    },
    numeroVinRules(v) {
      if (!v) {
        return true;
      }

      if (v.length > 20) {
        return this.$t('crudVeiculos.validation.numeroVinMaxLenght');
      }

      return true;
    },
    handleDone(data) {
      this.zipResult = {
        error: false,
        message: data.message || "File Processed Successfully!",
        messages: data.messages || [],
        processedFiles: data.processedFiles || 0
      };
      this.zipResultDialog = true;
    },
    handleError(data) {
      console.log("handleError", data);
      this.zipResult = {
        error: true,
        message: data.message || data.error || "Error Processing ZIP File",
        messages: []
      };
      this.zipResultDialog = true;
    },
    closeZipResultDialog() {
      this.zipResultDialog = false;
      this.zipResult = null;
    },
  },
};
</script>
